import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import './esign.css';
import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import './i18n';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import {unregister} from './registerServiceWorker'
import { BrowserRouter } from 'react-router-dom'
import { CookiesProvider } from 'react-cookie';

const rootElement = document.getElementById('root');

ReactDOM.render(
  <CookiesProvider>
     <BrowserRouter>
      <Suspense fallback="Loading...">
        <App />
      </Suspense>
    </BrowserRouter>
  </CookiesProvider>,    
  rootElement);

unregister();
